<div class="tab-content heuristic-container" data-crlat="tabContent">
    <!--- Racing Page -->
    <div
        class="container sk-container"
        [ngClass]="{
            'sk-loading': applyingParams || (displayNextRaces && !nextRacesLoaded) || (!displayNextRaces ? !featuredLoaded : !nextRacesLoaded),
        }">
        <loading-screen
            [displayed]="applyingParams || (displayNextRaces && !nextRacesLoaded) || (!displayNextRaces ? !featuredLoaded : !nextRacesLoaded)"
            [templateType]="'GENERIC'"></loading-screen>

        <div data-crlat="accordionsList">
            <!--- Sorting Panel -->
            @if (!applyingParams && isRacingPanel && featuredLoaded && display === 'future') {
                <switchers data-crlat="switchers" [filter]="filter" [switchers]="switchers" [detectGTMLocation]="'sublocation'"> </switchers>
            }
            @if (display === 'today') {
                <ng-template *ngTemplateOutlet="RacingFeaturedLazy"></ng-template>
            }
            @if (display === 'tomorrow') {
                <ng-template *ngTemplateOutlet="RacingFeaturedLazy"></ng-template>
            }

            <!-- Future events -->
            @if (!applyingParams && display === 'future') {
                <div data-crlat="racing.future">
                    @if (!responseError && racing.events?.length) {
                        <div data-crlat="racing.futureEvents">
                            <greyhound-future-tab
                                [filter]="filter"
                                [isExpanded]="isExpanded"
                                [orderedEvents]="orderedEvents"
                                [orderedEventsByTypeNames]="orderedEventsByTypeNames"
                                [filteredTypeNames]="filteredTypeNames"
                                [racingEvents]="racing.events"
                                [isEventOverlay]="isEventOverlay">
                            </greyhound-future-tab>
                        </div>
                    }
                    @if (responseError) {
                        <request-error [loadFailed]="responseError" (reloadFn)="reloadComponent()"></request-error>
                    }

                    <!-- Show only when no events -->
                    @if (!responseError && !racing.events?.length) {
                        <no-events></no-events>
                    }
                </div>
            }
            @if (!responseError && targetTab?.interstitialBanners?.bannerEnabled && !!lastBannerEnabled && !isPreviousUrlFuture && !isEventOverlay) {
                <virtual-entry-point-banner [targetTab]="targetTab" [isUnTiedSport]="true" [sportName]="sportName"></virtual-entry-point-banner>
            }
        </div>
    </div>
</div>

<ng-template #RacingFeaturedLazy>
    <lazy-component
        moduleUri="@lazy-modules-module/racingFeatured/racing-featured.module#RacingFeaturedModule"
        [hidden]="applyingParams"
        [inputs]="{
            sportId: categoryId,
            racing: racing,
            sectionTitle: sectionTitle,
            sportName: sportName,
            eventsOrder: eventsOrder,
            filter: filter,
            responseError: responseError,
            displayNextRaces: displayNextRaces,
            sportModule: sportModule,
            display: display,
            compName: 'greyhounds',
        }"
        [outputs]="['featuredLoaded']"
        (event)="handleFeaturedLoaded()"
        data-crlat="racing.greyhound">
    </lazy-component>
</ng-template>
